import { AspectRatio } from '../types'

interface GetOrientationAdjustedAspectRatioProps {
  aspectRatio: string
}

export const getOrientationAdjustedAspectRatio = ({
  aspectRatio,
}: GetOrientationAdjustedAspectRatioProps): AspectRatio => {
  const [numerator, denominator] = aspectRatio.split('/').map((part) => parseFloat(part.trim()))

  return `${denominator}/${numerator}`
}
